var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 471,
    height: 423,
    viewBox: "0 0 471 423",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.263 -34.9665L83.8176 202.956L3.42676 422.842L224.83 363.06L470.332 319.062L298.472 157.301L139.263 -34.9665Z",
    fill: "url(#paint0_radial_29_362)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.217 250.481L139.255 -34.9743L3.42676 422.842L137.869 287.694C142.707 282.823 146.48 277 148.95 270.594C151.42 264.188 152.533 257.339 152.217 250.481Z",
    fill: "url(#paint1_linear_29_362)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.263 287.608C144.84 277.571 150.257 264.279 149.627 250.418L139.255 -34.9745L152.217 250.48C152.497 257.335 151.369 264.174 148.901 270.575C146.433 276.976 142.678 282.802 137.868 287.694C103.577 322.994 3.44238 422.865 3.44238 422.865C3.44238 422.865 102.25 322.216 135.263 287.608Z",
    fill: "url(#paint2_radial_29_362)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M470.324 319.062L186.85 286.421C180.069 285.641 173.199 286.269 166.671 288.268C160.144 290.267 154.1 293.592 148.918 298.035L3.42676 422.842L470.324 319.062Z",
    fill: "url(#paint3_radial_29_362)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.87 300.451L3.42676 422.842L148.949 298.035C154.131 293.592 160.176 290.266 166.703 288.268C173.23 286.269 180.1 285.64 186.882 286.421L470.355 319.062L186.834 288.837C180.047 288.052 173.171 288.679 166.638 290.677C160.105 292.676 154.056 296.004 148.87 300.451Z",
    fill: "url(#paint4_radial_29_362)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.255 -34.9746L163.988 245.473C164.612 252.557 167.582 259.229 172.428 264.433C177.274 269.637 183.719 273.074 190.74 274.2L470.355 319.061",
    fill: "url(#paint5_linear_29_362)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M192.799 272.495L470.324 319.061L190.709 274.2C183.688 273.074 177.243 269.637 172.397 264.433C167.551 259.229 164.581 252.557 163.957 245.473L139.223 -34.9746L166.047 243.769C166.672 250.851 169.643 257.523 174.489 262.727C179.335 267.93 185.778 271.368 192.799 272.495Z",
    fill: "url(#paint6_radial_29_362)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_29_362",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.259 279.307) rotate(91.3609) scale(293.822 293.822)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFA7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FF77C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FF64BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#EE48C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CF18DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#C305E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CB05D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F105A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FF0596"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29_362",
    x1: 87.1392,
    y1: -36.2329,
    x2: 76.1864,
    y2: 424.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#641394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A938D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_29_362",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.6627 194.28) rotate(91.3609) scale(170.893 170.893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFA7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FF77C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FF64BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#EE48C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CF18DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#C305E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CB05D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F105A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FF0596"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_29_362",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.536 618.949) rotate(91.3609) scale(922.825 922.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FF78DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4E04C2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_29_362",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(235.426 371.465) rotate(27.7488) scale(168.703 168.703)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFA7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FF77C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FF64BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#EE48C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CF18DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#C305E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CB05D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F105A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FF0596"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_29_362",
    x1: 103.475,
    y1: 231.043,
    x2: 482.565,
    y2: 63.9034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A938D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#181866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#22176C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#3D167D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641394"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_29_362",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(281.71 183.795) rotate(27.7488) scale(184.214 184.214)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFA7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FF77C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FF64BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#EE48C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CF18DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#C305E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CB05D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F105A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FF0596"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShard);
export default __webpack_public_path__ + "static/media/shard.4aaa7611b4038f9262bb61e1e7cce4ea.svg";
export { ForwardRef as ReactComponent };